export default __webpack_public_path__ + "static/media/0xf4c83080e80ae530d6f8180572cbbf1ac9d5d435.cc18bcd0.webp";